module.exports = __webpack_public_path__ + "static/bookbyslot-f29eaff3453a8f20041f28506073ddc8.png";